<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="Chapter107">
<p class="centerImage"><img alt="images" id="img17" src="images/img17.jpg"/></p>
<p class="caption">Hauptmann Peter Spoden during training at C-Schule 17 at Pütnitz, Pomerania in 1942. <em class="italic">Spoden</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// HeroesAll_Chapter107.vue?31aa1f88